module.exports = __webpack_public_path__ + "img/video5.2deb0ce7.png";